import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Observable } from 'rxjs/Observable';
import * as words from './usernames.json';

@Injectable()
export class RandomUsernameService {

  constructor(/*private http: HttpClient*/) { }

  public static capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  public generate() {

    const firstWord = RandomUsernameService.capitalizeFirstLetter(
      words.verb_adjective[Math.floor(Math.random() * words.verb_adjective.length)]
    );
    const secondWord = RandomUsernameService.capitalizeFirstLetter(
      words.noun[Math.floor(Math.random() * words.verb_adjective.length)]
    );

    return Observable.of(firstWord + secondWord + Math.floor(Math.random() * 1000));
  }

  public random(): string {
    const firstWord = RandomUsernameService.capitalizeFirstLetter(
      words.verb_adjective[Math.floor(Math.random() * words.verb_adjective.length)]
    );
    const secondWord = RandomUsernameService.capitalizeFirstLetter(
      words.noun[Math.floor(Math.random() * words.verb_adjective.length)]
    );

    return firstWord + secondWord + Math.floor(Math.random() * 1000);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/random-username.service.ts